import { useQuery } from '@apollo/client'
import { Loader } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { clubSections, clubSectionsLegacy } from 'app/clubs/constants'
import { useClub, useClubMachineState } from 'app/clubs/hooks'
import { PageDetailFAQ } from 'components/page_detail'
import { useErrorModal, useVertExpEnabled } from 'hooks'
import { GET_PAGE_CONTENT } from 'queries'
import { CMSPageContent } from 'types'
import { ClubDetailTrialDisclosure } from '../ClubDetailTrialDisclosure'
import { ClubDetailSection } from './ClubDetailSection'
import {
  ClubDetailAbout,
  ClubDetailBooks,
  ClubDetailValueProps,
} from './content'
import { Club } from '@fable/types'

export const ClubDetailSections = () => {
  const { mediaQueries } = useTheme()
  const {
    state: { context },
  } = useClubMachineState()
  const isPremium = context.clubType === 'premium'
  const club = useClub()
  const vertExpEnabled = useVertExpEnabled()
  const clubContentType = club?.current_book?.type
  const pageSections = vertExpEnabled
    ? clubSections(clubContentType)
    : clubSectionsLegacy

  const isDisclosureHidden =
    !isPremium ||
    context.premiumUser ||
    context.isMember ||
    context.freeTrialStatus === 'expired'

  const { data, loading, error } = useQuery(GET_PAGE_CONTENT, {
    variables: {
      id: isPremium ? '7KRudaXOVQilo8MfhcJ2Vc' : '7AsvGWnA5l0Tdh0uNLtb6F',
    },
  })

  useErrorModal(error)

  const pageContent = data?.pageContent as CMSPageContent
  const valueProps = pageContent?.valueProps?.listCollection?.items
  const faqs = pageContent?.faqs?.listCollection?.items
  const loader = (
    <Loader
      className={css`
        height: 200px;
      `}
    />
  )

  const getSectionContent = (id: string) => {
    switch (id) {
      case 'about':
        return <ClubDetailAbout />
      case 'club-picks':
      case 'books':
        return <ClubDetailBooks />
      case 'how-it-works':
        return loading ? (
          loader
        ) : (
          <ClubDetailValueProps valueProps={valueProps} />
        )
      case 'faq':
        return loading ? loader : <PageDetailFAQ faqs={faqs} />
    }
  }

  const getSectionNote = (id: string) => {
    switch (id) {
      case 'about':
        return (
          <ClubDetailTrialDisclosure
            hidden={isDisclosureHidden}
            club={context.club as Club}
          />
        )
      default:
        return null
    }
  }

  return (
    <div
      className={css`
        padding-top: 34px;
        ${mediaQueries.tabletL} {
          padding-top: 54px;
        }
      `}
    >
      {pageSections.map((section, i) => (
        <ClubDetailSection
          key={i}
          anchorId={section.id}
          note={getSectionNote(section.id)}
          {...section.sectionProps}
        >
          {getSectionContent(section.id)}
        </ClubDetailSection>
      ))}
    </div>
  )
}
